<template>
<div style="padding-top:1rem">
  <div style="text-align:center">  <img
                        
                            src="../../assets/nu_chat.png"
                            style="width: 10rem; height: 5rem; margin: 10px"
                          />
</div>
        <p class="mb-10 text-center" style="font-size:18px">
          Choose the plan that feet better with your needs
        </p>

<div class="services">
<section class="pricecol"  v-for="plan in planDetails"
            v-bind:key="plan">
<div class="icon" v-if="plan.price != '0'">
<p style="position:relative;top:1rem;font-weight:500">${{ plan.price / 100 }}</p>
</div>
<div class="icon" v-if="plan.price == '0'">
<p style="position:relative;top:1rem;font-weight:500">Trail</p>
</div>
<h3><Span>{{ plan.planName }}</span></h3>
<ul>
<li>{{ plan.store }}&nbsp;Store</li>
<li>{{ plan.staff }}&nbsp;Staff</li>
<li>Cloud Based Storage</li>
<li>Add Store Frontend</li>


</ul>
<p>
<a v-if="plan.planName !='Business Pro'" class="button" @click="chosenplan(plan)"><span>Select</span></a>
<a v-if="plan.planName =='Business Pro'"  class="disabled"  ><span>Select</span></a>

</p>
</section>

</div>
</div>
            <!--//BLOCK ROW END-->
            
                    <!--//PRICE CONTENT END-->
                        

     
      <!-- <CCol lg="6" class="plans">
        <div class="font-size-24 poppins-medium mb-10 text-center">
          Choose the plan that feet better with your needs
        </div>

        <div class="plan1">
          <div
            class="col-md-4 col-sm-6 gutter-b"
            v-for="plan in planDetails"
            v-bind:key="plan"
          >
            <div class="px-5 text-center Pricing-outer text-white cus-stretch">
              <div class="plan2">
                <div class="font-size-21">{{ plan.planName }}</div>
                <div class="plan3" v-if="plan.price == '0'">Trial</div>
                <div class="plan3" v-if="plan.price != '0'">
                  ${{ plan.price / 100 }}
                </div>
              </div>

              <p>
                <span>{{ plan.store }}&nbsp;Store</span>
                <span>{{ plan.staff }}&nbsp;Staff</span>
                <span>&bull;&nbsp;Cloud Based Storage</span>
                <span>&bull;&nbsp;Add Store front</span>
              </p>
              <div class="plan4">
                <button class="plan5" @click="chosenplan(plan)">Select</button>
              </div>
            </div>

          </div>
        </div>
      </CCol> -->
</template>
<script>
import firebase from "firebase";
import { uuid } from "vue-uuid";
import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-sugar.css";
Vue.use(VueToast, {
  // One of the options
  position: "top-right",
});
export default {
  name: "plans",
  components: {},
  data() {
    return {
      planDetails: [],
      formData1:{},
    };
  },
  methods: {
    getplanlist() {
      const db = firebase.firestore();
      this.planDetails = [];
      db.collection("plans")
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            console.log(doc.data());
            this.planDetails = doc.data().planDetails;
          });
        });
    },
    chosenplan(det){
      this.str=JSON.stringify(det);
      this.par=JSON.parse(this.str)
      if(det.price == 0){
      const db = firebase.firestore();
      db.collection("users")
        .doc(this.doc)
        .update({
plandetails:this.par,
        }
        ).then(() => {
          localStorage.clear();
           window.location.reload();
            this.$router.push({ name: "Landing" });
              Vue.$toast.success("User registered successfully", {
            position: "top-right",
          });
        })
             

      }else{
      console.log(det);
      localStorage.setItem("PlanDetails",JSON.stringify(det))
         this.$router.push({ name: "subscription" });

      }

    }
  },
  created: function () {
    this.getplanlist();
  },
  mounted: function (){
     
      const db = firebase.firestore();
      this.planDetails = [];
      db.collection("users")
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            console.log(doc.data());
            this.doc = doc.id
          });
        });

  }
};
</script>
<style  lang="css">

.services
{
width:50rem;
overflow:auto;
margin:0 auto;
}
.pricecol
{
width:31%;
background:rgb(38, 48, 52);
min-height:30%;
border-radius:10px;
position:relative;
padding:30px 0px;
text-align:center;
font-family:'Assistant';
float:left;
margin-left:20px;
}
.icon
{
width:60px;
height:60px;
border-radius:100%;
background:rgb(108, 140, 54);
color:#fff;
text-align:center;
position:relative;
margin:0 auto;

}
.icon i
{
font-size:30px;
position:relative;
top:15px;
}
h3
{
text-align:center;
background:rgb(34, 43, 47);
text-align:center;
border-top:1px solid rgb(25, 31, 34);
border-bottom:1px solid rgb(51, 60, 64);
color:#fff;
}
h3 span
{
border-top:1px solid rgb(51, 60, 64);
border-bottom:1px solid  rgb(25, 31, 34);
display:block;
padding: 10px 0px;
font-family:verdana;
font-size:20px;
}
.button
{
border-radius:34px;
border:5px solid rgba(255, 255, 255, 0.07);
color:rgb(64, 85, 29);
font-size:16px;
margin-top:15px;
text-shadow: 0px 1px 0px rgba(255, 255, 255, 0.15);
cursor:pointer;
display:inline-block;
}
.button span
{
display:inline-block;
padding:10px 15px;
background: none repeat scroll 0% 0% rgb(108, 140, 54);
border-radius:20px;
box-shadow: 0px 0px 1px rgba(255, 255, 255, 0.3) inset, 0px 2px 0px rgba(255, 255, 255, 

0.1) inset;
}
a.disabled {
  display:inline-block;
padding:10px 15px;
border-radius:20px;
box-shadow: 0px 0px 1px rgba(255, 255, 255, 0.3) inset, 0px 2px 0px rgba(255, 255, 255, 

0.1) inset;
background:grey !important;
margin-top:15px;

}

ul
{
list-style-type:none;
padding:0px;
color:#fff;
font-family:verdana;
font-size:14px;
margin:0 auto;
text-align:center;
width:70%;
color:rgb(165, 174, 178);
border-bottom:1px solid rgb(51, 60, 64);
border-top:1px solid rgb(25, 31, 34);
}
li
{
padding:10px 0px;
border-top:1px solid rgb(51, 60, 64);
border-bottom:1px solid rgb(25, 31, 34);
}

</style>

